import { render, staticRenderFns } from "./IntroActionControlls.vue?vue&type=template&id=28ddf635&"
import script from "./IntroActionControlls.vue?vue&type=script&lang=js&"
export * from "./IntroActionControlls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports